import React, { useState } from "react";
import { map } from "lodash";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

type GroupedItemsArgs<T> = {
  title: string;
  allowToggle?: boolean;
  items: T[];
  renderItemComponent: (item: T, index: number | string) => React.ReactElement;
};

export default function GroupedItems<T>({
  items,
  title,
  allowToggle = true,
  renderItemComponent,
}: GroupedItemsArgs<T>) {
  const [open, setOpen] = useState(true);

  function toggleOpen() {
    setOpen(!open);
  }

  return (
    <div className="groupedRows">
      {title ? (
        <div
          className={classNames("groupedRowsHeader mx-1 my-2 cursor-pointer", {
            allowToggle,
          })}
          onClick={allowToggle ? toggleOpen : undefined}
        >
          {allowToggle ? (
            <FontAwesomeIcon
              icon={faChevronRight}
              className={classNames(
                "fa-xs text-gray-500 transition-transform mr-2",
                {
                  "rotate-90": open,
                },
              )}
            />
          ) : null}
          <span className="title font-semibold uppercase text-sm text-muted">
            {title}
          </span>
        </div>
      ) : null}
      {open ? (
        <div className="chat__new_grouped_rows_container">
          {map(items, (item, index) => renderItemComponent(item, index))}
        </div>
      ) : null}
    </div>
  );
}
